import getArticleIdFromURL from './getArticleIdFromURL';

export default getArticleIdFromURL;
